import getAssociationKeysReduxUtil from '../../../redux/utils/get-associations-keys'
import { getValueReduxUtil } from '../../../redux/utils/get-value'
import getOptionalAssociationKeysReduxUtil from '../../../redux/utils/get-optional-association-keys'

export default function hasLoadedAssociationsReduxUtil (instance, associationKeys) {
  associationKeys = associationKeys || getAssociationKeysReduxUtil(instance)
  const optionalAssociationKeys = getOptionalAssociationKeysReduxUtil(instance)
  return associationKeys.every(key => {
    if (optionalAssociationKeys.includes(key)) {
      return true
    }

    return getValueReduxUtil(instance, key) != null
  })
}
